import "./Disability.css";

function Disability(): JSX.Element {
    return (
        <div className="Disability">
            Disability services and discounts
        </div>
    );
}

export default Disability;
